import { render, staticRenderFns } from "./BlockType19List.vue?vue&type=template&id=620d7cce&scoped=true"
import script from "./BlockType19List.vue?vue&type=script&lang=ts"
export * from "./BlockType19List.vue?vue&type=script&lang=ts"
import style0 from "./BlockType19List.vue?vue&type=style&index=0&id=620d7cce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../src-custom-solutions/president-election/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620d7cce",
  null
  
)

export default component.exports